import React from 'react';

const ImageInfo = props => {
 
    return (
        <div>
            <h5 className="font-weight-bold text-capitalize">{props.desc}</h5>
            <p className="font-italic">Photographed by {props.author}</p>
            <p>Magna enim quis enim Lorem Lorem ipsum culpa commodo labore quis aute qui reprehenderit. Non velit nostrud quis incididunt qui laborum non sit nisi officia aliqua labore excepteur. Irure sint sint culpa labore incididunt amet amet ullamco anim do adipisicing Lorem aliquip voluptate. Do commodo irure anim aliqua proident laborum cillum eu in esse enim adipisicing. Non commodo ipsum ut pariatur eiusmod enim occaecat Lorem esse aliqua. Velit voluptate consequat esse veniam tempor ipsum qui deserunt. Sit adipisicing aliquip pariatur ex do nostrud aliqua et.</p>
        </div>
    )
}

export default ImageInfo;